import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-6985c8ce.js';
import './chunk-d0a313ea.js';
import './chunk-cdfca85b.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-d1591eb8.js';
import './chunk-42f463e6.js';
import './chunk-4d76806f.js';
import './chunk-eb60b35a.js';
import './chunk-77ffdf8b.js';
import { D as Datepicker } from './chunk-66a4ceca.js';
export { D as BDatepicker } from './chunk-66a4ceca.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/datepicker.js
// module id = 52
// module chunks = 10